module.exports = __webpack_public_path__ + "img/login-logo-image.a41f0ac1.svg";